import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  BookOpen,
  Music,
  Book,
  Sparkles,
  BookMarked,
  Grid,
  Feather,
  MessageCircle,
  Mic,
  Headphones,
  FileText,
  Film,
  ChevronRight,
} from "lucide-react";

const FeedCategories = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const navigate = useNavigate();

  const feedCategories = [
    { id: 0, title: "For You", icon: Grid, route: "/feed?type=for_you" },
    { id: 1, title: "Poetry", icon: Feather, route: "/feed?type=Poetry" },
    { id: 2, title: "Shayari", icon: Sparkles, route: "/feed?type=Shayari" },
    { id: 3, title: "Ghazal", icon: BookOpen, route: "/feed?type=Ghazal" },
    { id: 4, title: "Song", icon: Music, route: "/feed?type=Song" },
    { id: 5, title: "Rap", icon: Mic, route: "/feed?type=Rap" },
    { id: 6, title: "Hip-Hop", icon: Headphones, route: "/feed?type=Hip-Hop" },
    { id: 7, title: "Novel", icon: Book, route: "/feed?type=Novel" },
    { id: 8, title: "Story", icon: BookMarked, route: "/feed?type=Story" },
    { id: 9, title: "Book", icon: FileText, route: "/feed?type=Book" },
    { id: 10, title: "Script", icon: Film, route: "/feed?type=Script" },
    { id: 11, title: "Quote", icon: MessageCircle, route: "/feed?type=Quote" }
  ];

  const handleCardClick = (route) => {
    navigate(route);
  };

  return (
    <>
      {/* Custom breakpoint */}
      <style jsx>{`
        @media (min-width: 1285px) {
          .feed-heading {
            display: block !important;
          }
        }
      `}</style>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
        <div className="hidden feed-heading mb-8 sm:mb-12 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black mb-3 sm:mb-4">
            Your feed, from people you follow
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto">
            Explore posts, stories, and poetry shared by writers you follow — filter by category to see what inspires you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:flex sm:flex-wrap gap-4 sm:gap-3 sm:justify-center">
          {feedCategories.map((category) => {
            const IconComponent = category.icon;
            return (
              <div
                key={category.id}
                onClick={() => handleCardClick(category.route)}
                onMouseEnter={() => setHoveredCard(category.id)}
                onMouseLeave={() => setHoveredCard(null)}
                className={`flex items-center justify-between sm:justify-start gap-4 sm:gap-3 px-6 sm:px-6 py-4 sm:py-4 bg-white border border-gray-300 rounded-full cursor-pointer transition-all duration-200 shadow-sm ${
                  hoveredCard === category.id
                    ? "border-black hover:bg-gray-50 hover:shadow-md scale-105"
                    : "hover:border-gray-400 hover:shadow"
                }`}
              >
                <div className="flex items-center gap-4 sm:gap-3">
                  <IconComponent
                    size={24}
                    className="text-black flex-shrink-0 sm:size-5"
                    strokeWidth={2}
                  />
                  <span className="text-lg sm:text-base font-medium text-black whitespace-nowrap">
                    {category.title}
                  </span>
                </div>

                <ChevronRight
                  size={20}
                  className="text-gray-400 flex-shrink-0 sm:hidden"
                  strokeWidth={2}
                />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FeedCategories;